import { eventBus, EVENTS } from '../EventBus';
import { LESSONS } from '../data/lessons';
import type { NetworkComponent } from '../types';

export function showComponentLesson(component: NetworkComponent, label: string): void {
  eventBus.emit(EVENTS.lesson, { title: label, body: LESSONS[component] });
  eventBus.emit(EVENTS.announce, `${label}. ${LESSONS[component]}`);
}

